import styles from './MessageBox.module.scss';

import { TextInput, Textarea, FileInput } from '@mantine/core';

import { IconUpload } from '@tabler/icons-react';

import { wrapImageUploadProps } from '#/components/ui/messages/MessageEditor/MessageImageUpload';
import { MessageBoxAction } from '#/components/ui/messages/model';

import { useActionEditorFormContext } from '../../context';

import { makeKFunc } from '../utils';

export const MessageBoxFields = ({ keyPrefix }: { keyPrefix?: string }) => {
  const form = useActionEditorFormContext();

  const k = makeKFunc(keyPrefix);
  const type = form.getInputProps(k`type`).value;

  if (type !== 'message_box') {
    return null;
  }

  const value = form.getInputProps(k`attribute_schema.image`).value;

  const imageFieldOps = wrapImageUploadProps({
    value,
    setValue: (v) => form.setFieldValue(k`attribute_schema.image`, v),
  });

  return (
    <>
      <TextInput
        label="標題"
        withAsterisk
        placeholder="請輸入標題，建議 20 字內。"
        key={form.key(k`attribute_schema.title`)}
        {...form.getInputProps(k`attribute_schema.title`)}
      />
      <Textarea
        label="內文"
        withAsterisk
        placeholder="請輸入內文，建議 50 字內。"
        minRows={3}
        autosize
        key={form.key(k`attribute_schema.message`)}
        {...form.getInputProps(k`attribute_schema.message`)}
      />
      <FileInput
        accept="image/png,image/jpeg"
        placeholder="比例：280x172 px（橫式）"
        rightSection={<IconUpload />}
        label="圖片"
        value={imageFieldOps.file}
        onChange={(file) => {
          if (!file) return;
          imageFieldOps.upload(file);
        }}
      />
      <TextInput
        label="按鈕的文案"
        withAsterisk
        placeholder="請輸入按鈕文案"
        key={form.key(k`attribute_schema.positive_button`)}
        {...form.getInputProps(k`attribute_schema.positive_button`)}
      />
    </>
  );
};

export const MessageBoxPreview = ({ value }: { value: MessageBoxAction }) => {
  const { attribute_schema: attributes } = value;
  const imageSrc = value.attribute_schema.image;

  return (
    <div className={styles.preview}>
      <div className={styles.hero}>
        <button className={styles.closeBtn} onClick={undefined}>
          ✕
        </button>
        {imageSrc && <img src={imageSrc} alt="hero placeholder" />}
      </div>

      <div className={styles.body}>
        <div className={styles.title}>{attributes.title || '{標題}'}</div>
        <div className={styles.content}>
          {attributes.message ||
            '{內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文}'}
        </div>
      </div>

      <div className={styles.ctaList}>
        <button className={styles.ctaBtn}>
          {attributes.positive_button || '確認'}
        </button>
      </div>
    </div>
  );
};
